import React from "react";
import { Link } from "react-router-dom";

const InnerServicesAreaItem = ({ item }) => {
  return (
    <div className="inner-services-item">
      <div className="inner-services-icon">
        <img src={item.src} alt={item.title} className="service-icon" />
      </div>
      <div className="inner-services-content">
        <h4 className="title">
          <Link to={item.url}>{item.title}</Link>
        </h4>
        <p>{item.desc}</p>
      </div>
    </div>
  );
};

export default InnerServicesAreaItem;
